import React from "react";
import EiaDialog from "./EiaDialog";
import {useCookies} from "react-cookie";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import EiaButton from "../EiaButton";
import {deserialize, serialize} from "../../commons/Utils/SerializationUtils";

const whiteTextStyle = {
    color: 'white',
    "--fc-daygrid-day-number-display'": 'none'
};

function OnlineAvailabilityDialog(props) {
    const {onClose, open, user, editable=false, onlineAvailability, setOnlineAvailability} = props;

    const [cookies, setCookies, removeCookies] = useCookies(['darkMode']);
    const darkMode = cookies.darkMode === undefined ? true : cookies.darkMode;

    const [events, setEvents] = React.useState([])
    const [internalOnlineAvailability, setInternalOnlineAvailability] = React.useState("")

    React.useEffect(() => {
        if(internalOnlineAvailability !== onlineAvailability) {
            setInternalOnlineAvailability(onlineAvailability);
            const deserializedEvents = deserialize(onlineAvailability, []);
            setEvents(deserializedEvents);
        }
    }, [onlineAvailability])

    const handleSelect = (info) => {
        if(!editable) {
            return;
        }

        const newEvent = {
            start: info.startStr,
            end: info.endStr,
        };

        if(events.some((event) => {
            return event.start === info.startStr;
        })) {
            console.error("Multiple events with same start time are not allowed");
            info.revert();
        } else {
            setEvents([...events, newEvent]);
        }
    };

    const handleEventClick = (clickInfo) => {
        if(editable) {
            setEvents((prevEvents) =>
                prevEvents.filter((event) => {
                    return !(event.start === clickInfo.event.startStr && event.end === clickInfo.event.endStr);
                })
            );
        }
    };

    const removeAllEvents = () => {
        if(!editable) {
            return;
        }

        setEvents([])
    };

    const updateOnlineAvailabilityAndClose=function() {
        if(editable) {
            const serialized = serialize(events);
            setOnlineAvailability(serialized);
        }
        onClose();
    }

    const handleEventResize = (info) => {
        if(!editable) {
            return;
        }

        const temp = Object.assign([], events);

        let updated = false;
        temp.forEach(e => {
            if(e.start === info.event.startStr) {

                if(updated) {
                    console.error("There are multiple events with the same start date: " + e.start)
                } else {
                    e.end = info.event.endStr;
                    updated = true;
                }
            }
        })

        if(updated) {
            setEvents(temp);
        } else {
            console.error("Resize not possible since there is no event with start time ", info.event.startStr);
            info.revert();
        }
    };

    const handleEventDrop = (info) => {
        if(!editable) {
            return;
        }

        const newStart = info.event.startStr;
        const newEnd = info.event.endStr

        let temp = Object.assign([], events);

        if(temp.some((event) => {
            return event.start === newStart;
        })) {
            console.error("Multiple events with same start time are not allowed");
            info.revert();
        } else {
            temp = temp.filter((event) => {
                return !(event.start === info.oldEvent.startStr);
            });

            const newEvent = {
                start: newStart,
                end: newEnd,
            };

            temp = [...temp, newEvent];

            setEvents(temp);
        }
    };


    return (
        <EiaDialog title={"Online Availability from '"+user+"'"} open={open} onClose={updateOnlineAvailabilityAndClose} isLoading={false} fullWidth>
            <div className="fullcalendar" style={darkMode ? whiteTextStyle : {'--fc-daygrid-day-number-display': 'none'}}>
                <FullCalendar
                    timeZone="local"
                    slotDuration="01:00:00"
                    headerToolbar={false}
                    allDaySlot={false}
                    nowIndicator={false}
                    firstDay={1}
                    slotLabelInterval="01:00"
                    initialDate="2025-10-06" // beliebiger Montag
                    dayHeaderContent={(args) => {
                        const weekdayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
                        const dayIndex = args.date.getDay(); // 0 = Sunday
                        return weekdayNames[dayIndex];
                    }}

                    plugins={[timeGridPlugin, interactionPlugin]}
                    initialView="timeGridWeek"
                    editable={editable}
                    selectable={editable}
                    selectMirror={true}

                    eventResize={handleEventResize}
                    eventDrop={handleEventDrop}
                    events={events}
                    select={handleSelect}
                    eventClick={handleEventClick}
                />
            </div>
            {
                editable ? <EiaButton onClick={removeAllEvents}>Remove all</EiaButton> : null
            }
        </EiaDialog>
    );
}

export default OnlineAvailabilityDialog;